/**
 * Header subscription / Activate Plan control.
 * Disabled for the AiSensy platform — no plan purchase UI in the chrome.
 */
const SubscriptionStatus = () => null;

export default SubscriptionStatus;
